import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { modal } from '../../core/utilities/modal'
import NavLink from '../Routes/NavLink'
import { payouts } from '../../core/controllers/Payouts'
import { user } from '../../core/controllers/user';
import { billing } from '../../core/controllers/Billing'
import DotProgress from '../../core/utilities/DotProgress';

const payoutsController = payouts;

export default class PayoutsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            payouts: null,
            addPayout: false,
            editPayout: false,
            selected_id: 0,
            startDate: moment(props.start).valueOf(),
            endDate: moment(props.end).valueOf(),
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        payouts.getPayouts(
          self.state.startDate,
          self.state.endDate,
          function(response) {
            self.setState({
                payouts: response.data
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatLastLogin(cell, row) {
        return moment.utc(row.last_login).local().format('MMMM Do YYYY, h:mm:ss a');
    }

    formatJoinDate(cell, row) {
        if(cell) {
            return moment(cell).format('D MMM YYYY');
        } else {
            return 'Not Set';
        }
    }

    formatPercentage(cell, row) {
        return row.fee_percentage + "%";
    }

    addPayout() {
        this.setState({editFee: false, addFee: true, selected_id: 0})
    }

    goBack() {
        var self = this;
        fees.getFees(function(response) {
            self.setState({
                fees: response.data,
                editFee: false, addFee: false, selected_id: 0
            })
        });
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseFloat(value) / 100;
        money = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(money)
        return money;
    }

    formatGlobal(cell, row) {
        if (row.is_global == 1) {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    didSelectRow(row) {
        this.setState({addFee: false})
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    formatStatus(cell, row) {
        var status = <DotProgress dotPos={2} date={row.due_at}/>
        if (cell == 'PAID') {
            status = <DotProgress dotPos={3} date={row.due_at}/>
        } else if (cell == 'VOID') {
            status = '<span class="important-small-gray">Cancelled</span>';
        } else if (cell == 'EXPIRED') {
            status = '<span class="important-small-red">Expired</span>';
        } else if (cell == 'FAILED') {
            status = '<span class="important-small-red">Failed</span>';
        } else if (cell == 'REFUNDED') {
            status = '<span class="important-small-blue">Refund</span>';
        } else if (cell == 'NONE') {
            status = <DotProgress dotPos={1} date={row.due_at}/>
        }

        return status;
    }

    voidTransaction(payout) {
        var self = this;
        payout['is_payout'] = true;
        modal.showDangerModalWithOK("Cancel Payment", "Are you sure you want to cancel this payment?", "Cancel");
        jQuery(".move-on").on('click',function() {
            billing.voidPayoutTransaction(payout, function(){
                modal.showInfo("Payment was cancelled.", "success", "top", "center");
                payouts.getPayouts(function(response) {
                    self.setState({
                        payouts: response.data
                    });
                });
            });
        });
    }

    deleteTransaction(payout) {
        var self = this;
        modal.showDangerModalWithOK("Cancel Payment", "Are you sure you want to cancel this payment?", "Cancel");
        jQuery(".move-on").on('click',function() {
            // tenantBilling.deleteTransaction(invoice, function(){
            //     modal.showInfo("Payment was cancelled.", "success", "top", "center");
            //     if(self.props.tenantId) {
            //         tenantBilling.getTransactionHistoryWithId(function(response){
            //             self.setState({
            //                 transactionHistory: response.data
            //             });
            //         }, self.props.tenantId);
            //     } else {
            //         tenantBilling.getTransactionHistory(function(response){
            //             self.setState({
            //                 transactionHistory: response.data
            //             });
            //         });
            //     }
            // });
        });
    }

    actions(cell, row) {
        return (
            <span>
            {/* <span onClick={this.downloadInvoice.bind(this, row)}>
                <i class="pe-7s-download download-invoice"></i>
            </span> */}
            { row.status == 'IN_PROCESS' && (
            <span onClick={this.voidTransaction.bind(this, row)}>
                <i class="pe-7s-close-circle download-invoice"></i>
            </span>
            )}
            {/* { row.status == 'NONE' && (
            <span onClick={this.deleteTransaction.bind(this, row)}>
                <i class="pe-7s-close-circle download-invoice"></i>
            </span>
            )} */}
            </span>
        )
    }

    formatDate(cell, row) {
        return moment.utc(cell).local().format('MMMM Do YYYY');
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount((row.payout - row.fee_charge));
    }

    render(){
        if (
            this.state.startDate !== moment(this.props.start).valueOf() ||
            this.state.endDate !== moment(this.props.end).valueOf()
        ) {
          var self = this;
          payoutsController.getPayouts(
            this.state.startDate,
            this.state.endDate,
            function(response) {
              self.setState({
                startDate: moment(self.props.start).valueOf(),
                endDate: moment(self.props.end).valueOf(),
                payouts: response.data,
              })
          });
        }

        const options = {
            onRowClick: this.didSelectRow.bind(this)
        };

        var self        = this;
        var payouts     = this.state.payouts;
        const addPayout = this.state.addPayout;

        if(payouts != null) {
            payouts = this.state.payouts.map(function(payout) {
                return {
                    payout_id: payout.payout.payout_id,
                    name: payout.payout.name,
                    company_name: payout.owner.company_name,
                    payout: payout.payout.payout,
                    fee_charge: payout.payout.fee_charge,
                    status: payout.status,
                    created_at: payout.payout.created_at,
                    transaction_id: payout.payout.transaction_id
                }
            });
        }

        return (
            <div class="row">
                {addPayout == false && (
                <div class="col-md-12">
                    <div class="content">
                    {payouts != null ? (
                        window.innerWidth < 992 ? (
                        <BootstrapTable data={payouts} version='4' striped search pagination hover>
                            <TableHeaderColumn dataField='payout_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='payout' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                            <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                        </BootstrapTable>
                        ) : (
                        <BootstrapTable data={payouts} version='4' striped search pagination hover options={options}>
                            <TableHeaderColumn dataField='payout_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='name' dataSort={ true }>Description</TableHeaderColumn>
                            <TableHeaderColumn dataField='company_name' dataSort={ true }>Owner</TableHeaderColumn>
                            <TableHeaderColumn dataField='payout' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                            <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate} dataSort={ true }>Payment Date</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={this.actions.bind(this)} width="100"></TableHeaderColumn>
                        </BootstrapTable>
                        )
                    ) : (
                        <p class="col-md-12">No payouts yet.</p>
                    )}
                    </div>
                    { user.userInfo != null && user.userInfo.user_type_alias == 'admin' && (
                    <div class="content" style={{float: "right"}}>
                        <NavLink to={"/owner/payout/new"}>
                            <button type="button" id="add-owner" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill" autoComplete="off">
                                Create Payout
                            </button>
                            <div class="clearfix"></div>
                        </NavLink>
                    </div>
                    )}
                </div>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Payouts/PayoutsList.jsx